// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_MultiSet from "../Data.MultiSet/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var zero = /* #__PURE__ */ Data_Numeric.zero(Data_Numeric.additiveInt);
var find = /* #__PURE__ */ Data_Foldable.find(Data_Foldable.foldableArray);
var fromFoldable = /* #__PURE__ */ Data_Set.fromFoldable(Data_Foldable.foldableArray);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableTuple)(Data_Maybe.applicativeMaybe);
var add = /* #__PURE__ */ Data_Numeric.add(Data_Numeric.additiveInt);
var foldl = /* #__PURE__ */ Data_Foldable.foldl(Data_Foldable.foldableArray);
var OMS = function (x) {
    return x;
};
var First = /* #__PURE__ */ (function () {
    function First() {

    };
    First.value = new First();
    return First;
})();
var Last = /* #__PURE__ */ (function () {
    function Last() {

    };
    Last.value = new Last();
    return Last;
})();
var unOMS = function (v) {
    return v;
};
var toOccurArray = unOMS;
var toMultiSet = function (dictOrd) {
    var $122 = Data_MultiSet.fromOccurArray(dictOrd);
    return function ($123) {
        return $122(toOccurArray($123));
    };
};
var size = /* #__PURE__ */ (function () {
    var $124 = Data_Numeric.sum(Data_Foldable.foldableArray)(Data_Numeric.additiveInt);
    var $125 = map(Data_Tuple.snd);
    return function ($126) {
        return $124($125(unOMS($126)));
    };
})();
var showOrderedMultiSet = function (dictShow) {
    var show = Data_Show.show(Data_Show.showArray(Data_Tuple.showTuple(dictShow)(Data_Show.showInt)));
    return {
        show: function (x) {
            return "(fromOccurArray " + (show(toOccurArray(x)) + ")");
        }
    };
};
var ordOrderedMultiSet = function (dictOrd) {
    return Data_Ord.ordArray(Data_Tuple.ordTuple(dictOrd)(Data_Ord.ordInt));
};
var occur = function (dictEq) {
    var eq = Data_Eq.eq(dictEq);
    return function (x) {
        var $127 = Data_Maybe.maybe(zero)(Data_Tuple.snd);
        var $128 = find(function (v) {
            return eq(v.value0)(x);
        });
        return function ($129) {
            return $127($128(unOMS($129)));
        };
    };
};
var numDistinctElems = function ($130) {
    return Data_Array.length(unOMS($130));
};
var $$null = function ($131) {
    return Data_Array["null"](unOMS($131));
};
var findIndex = function (dictEq) {
    var eq = Data_Eq.eq(dictEq);
    return function (needle) {
        return function (v) {
            return Data_Array.findIndex(function (v1) {
                return eq(v1.value0)(needle);
            })(v);
        };
    };
};
var eqOrderedMultiSet = function (dictEq) {
    return Data_Eq.eqArray(Data_Tuple.eqTuple(dictEq)(Data_Eq.eqInt));
};
var empty = [  ];
var distinctElems = /* #__PURE__ */ (function () {
    var $132 = map(Data_Tuple.fst);
    return function ($133) {
        return $132(unOMS($133));
    };
})();
var toSet = function (dictOrd) {
    var $134 = fromFoldable(dictOrd);
    return function ($135) {
        return $134(distinctElems($135));
    };
};
var alterCount = function (dictEq) {
    var eq = Data_Eq.eq(dictEq);
    return function (f) {
        return function (insertPos) {
            return function (x) {
                return function (v) {
                    var to = function (n) {
                        if (n <= zero) {
                            return Data_Maybe.Nothing.value;
                        };
                        if (Data_Boolean.otherwise) {
                            return new Data_Maybe.Just(n);
                        };
                        throw new Error("Failed pattern match at Data.OrderedMultiSet (line 88, column 3 - line 88, column 25): " + [ n.constructor.name ]);
                    };
                    var insertAt = function (v1) {
                        if (v1 instanceof First) {
                            return Data_Array.cons;
                        };
                        if (v1 instanceof Last) {
                            return Data_Function.flip(Data_Array.snoc);
                        };
                        throw new Error("Failed pattern match at Data.OrderedMultiSet (line 93, column 3 - line 93, column 66): " + [ v1.constructor.name ]);
                    };
                    var alterExisting = bind(Data_Array.findIndex(function (v1) {
                        return eq(v1.value0)(x);
                    })(v))(function (index) {
                        return Data_Array.alterAt(index)(traverse(function ($136) {
                            return to(f($136));
                        }))(v);
                    });
                    if (alterExisting instanceof Data_Maybe.Just) {
                        return alterExisting.value0;
                    };
                    if (alterExisting instanceof Data_Maybe.Nothing) {
                        var count = f(0);
                        var $98 = count > 0;
                        if ($98) {
                            return insertAt(insertPos)(new Data_Tuple.Tuple(x, count))(v);
                        };
                        return v;
                    };
                    throw new Error("Failed pattern match at Data.OrderedMultiSet (line 73, column 3 - line 81, column 20): " + [ alterExisting.constructor.name ]);
                };
            };
        };
    };
};
var $$delete = function (dictEq) {
    return alterCount(dictEq)(Data_Function["const"](zero))(Last.value);
};
var alterValueMatching = function (dictEq) {
    var occur1 = occur(dictEq);
    var delete1 = $$delete(dictEq);
    return function (pred) {
        return function ($$new) {
            return function (s) {
                var newCount = (function () {
                    var $99 = pred($$new);
                    if ($99) {
                        return 0;
                    };
                    return occur1($$new)(s);
                })();
                var v = (function () {
                    var $100 = pred($$new);
                    if ($100) {
                        return s;
                    };
                    return delete1($$new)(s);
                })();
                return map(function (v1) {
                    var $103 = pred(v1.value0);
                    if ($103) {
                        return new Data_Tuple.Tuple($$new, add(v1.value1)(newCount));
                    };
                    return v1;
                })(v);
            };
        };
    };
};
var insertMany = function (dictEq) {
    var alterCount1 = alterCount(dictEq);
    return function (pos) {
        return function (x) {
            return function (delta) {
                return alterCount1(function (v) {
                    return add(v)(delta);
                })(pos)(x);
            };
        };
    };
};
var fromOccurArray = function (dictEq) {
    var insertMany1 = insertMany(dictEq);
    return foldl(function (acc) {
        return function (v) {
            return insertMany1(Last.value)(v.value0)(v.value1)(acc);
        };
    })(empty);
};
var restoreOrder = function (dictEq) {
    var findIndex1 = findIndex(dictEq);
    var fromOccurArray1 = fromOccurArray(dictEq);
    return function (defaultOrder) {
        var lookupItem = function (v) {
            return findIndex1(v.value0)(defaultOrder);
        };
        var compareNothingLast = function (dictOrd) {
            var compare = Data_Ord.compare(dictOrd);
            return function (v) {
                return function (v1) {
                    if (v instanceof Data_Maybe.Just && v1 instanceof Data_Maybe.Just) {
                        return compare(v.value0)(v1.value0);
                    };
                    if (v instanceof Data_Maybe.Just && v1 instanceof Data_Maybe.Nothing) {
                        return Data_Ordering.LT.value;
                    };
                    if (v instanceof Data_Maybe.Nothing && v1 instanceof Data_Maybe.Nothing) {
                        return Data_Ordering.EQ.value;
                    };
                    if (v instanceof Data_Maybe.Nothing) {
                        return Data_Ordering.GT.value;
                    };
                    throw new Error("Failed pattern match at Data.OrderedMultiSet (line 176, column 5 - line 180, column 23): " + [ v.constructor.name, v1.constructor.name ]);
                };
            };
        };
        var $137 = Data_Array.sortBy(Data_Function.on(compareNothingLast(Data_Ord.ordInt))(lookupItem));
        return function ($138) {
            return fromOccurArray1($137(Data_MultiSet.toOccurArray($138)));
        };
    };
};
var insert = function (dictEq) {
    var insertMany1 = insertMany(dictEq);
    return function (pos) {
        return function (x) {
            return insertMany1(pos)(x)(1);
        };
    };
};
var fromArray = function (dictOrd) {
    var insert1 = insert(dictOrd.Eq0());
    return foldl(function (acc) {
        return function (x) {
            return insert1(Last.value)(x)(acc);
        };
    })(empty);
};
var semigroupOMS = function (dictEq) {
    var insertMany1 = insertMany(dictEq);
    return {
        append: function (xs) {
            return function (v) {
                return foldl(function (acc) {
                    return function (v1) {
                        return insertMany1(Last.value)(v1.value0)(v1.value1)(acc);
                    };
                })(xs)(v);
            };
        }
    };
};
var monoidOMS = function (dictEq) {
    var semigroupOMS1 = semigroupOMS(dictEq);
    return {
        mempty: empty,
        Semigroup0: function () {
            return semigroupOMS1;
        }
    };
};
export {
    First,
    Last,
    empty,
    alterCount,
    alterValueMatching,
    insert,
    insertMany,
    $$delete as delete,
    occur,
    findIndex,
    toOccurArray,
    fromOccurArray,
    fromArray,
    distinctElems,
    toMultiSet,
    toSet,
    $$null as null,
    size,
    numDistinctElems,
    restoreOrder,
    eqOrderedMultiSet,
    ordOrderedMultiSet,
    semigroupOMS,
    monoidOMS,
    showOrderedMultiSet
};
